import axios from 'axios'
import { getFormattedMoneyString, getLocalURL } from '../../../scripts/helpers/globale'

export default class SearchMobile {
  constructor(component) {
    this.dom = {
      $component: component,
      $input: component.querySelector('.js-searchMobileInput'),
      $mobileNav: document.querySelector('.js-navigationMenuMobile'),
      $resultsContainer: document.querySelector('.js-searchMobileResults'),
      $mobileNav: document.querySelector('.js-navigationMenuMobile')
    }
    this.state = {
      searchActiveClass: 'searchActive',

      predictiveSearchTimeout: null,
      showResultsClass: 'showResults'
    }
    this.showSearchHandler = this.showSearch.bind(this)
    this.predictiveSearchHandler = this.predictiveSearch.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const {dom} = this
    dom.$input.addEventListener('focus', this.showSearchHandler)
    dom.$input.addEventListener('input', this.predictiveSearchHandler)
  }

  showSearch() {
    const {dom, state} = this
    dom.$mobileNav.classList.add(state.searchActiveClass)
  }

  predictiveSearch(e) {
    const {state} = this
    clearTimeout(state.predictiveSearchTimeout)
    state.predictiveSearchTimeout = setTimeout(() => this.search(e.target.value), 500)
  }

  async search(value) {
    const {dom, state} = this

    if (!value) {
      dom.$mobileNav.classList.remove(state.showResultsClass)
      return
    }

    try {
      const url = getLocalURL(`/search/suggest.json?q=${value}&resources[type]=product&resources[limit]=6&resources[options][fields]=product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor`)
      const {data} = await axios.get(url)
      const products = data.resources.results.products

      if (products.length === 0) {
        dom.$mobileNav.classList.remove(state.showResultsClass)
        return
      }

      dom.$mobileNav.classList.add(state.showResultsClass)
      this.renderResults(products)
    } catch(e) {
      console.log(`Error searching "${value}"`, e)
    }
  }

  renderResults(products) {
    const {dom} = this
    dom.$resultsContainer.innerHTML = ''

    products.forEach(product => {
      const {title, price, url} = product
      const imgSrc = product.featured_image.url
      const a = document.createElement('a')
      const image = new Image()

      let priceInCents = (price * 100).toString()

      image.src = imgSrc
      image.alt = title
      a.className = 'NavigationMenuMobile__searchItem'
      a.href = url
      a.innerHTML = `
        <div class="NavigationMenuMobile__searchItem__img imgUnloaded"></div>
        <span class="NavigationMenuMobile__searchItem__title btn-link">${title}</span>
        <span class="NavigationMenuMobile__searchItem__price rmp">
          <span class="currency-formatting">
            ${getFormattedMoneyString(priceInCents)}
          </span>
        </span>
      `

      image.addEventListener('load', () => {
        const imgContainer = a.querySelector('.NavigationMenuMobile__searchItem__img')
        imgContainer.append(image)
        imgContainer.classList.remove('imgUnloaded')
      })
      dom.$resultsContainer.append(a)
    })
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.SearchMobile = this
  }
}
